import { getChoiceCartListApi, calculatePriceAllIncludeApi } from '@/apis/shopcart'
import { useGlobal } from '@/util/useLoading'
import { computed, onMounted, ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { debounce } from 'lodash'
import { ElMessage as message } from 'element-plus'
import store, { isD2C } from '@/store'
import { ShopType } from '@/common/const'
export const priceTypeList: any = ref([])
// 获取计价规格名称
export const getPriceTypeInfo = async (adaptType: string) => {
  if (priceTypeList.value.length === 0) {
    const { data } = await request.settlement.allInclude.categoryAdaptInfo()
    priceTypeList.value = data ?? []
  }
  let text = null
  let text2 = null
  let category: any = {}
  let adapt: any = {}
  priceTypeList.value.forEach((item: any) => {
    item.adaptInfoList?.forEach((temp: any) => {
      if (temp.adaptType === adaptType) {
        text = `${item.categoryNameJp}(${temp.adaptTypeNameJp})`
        text2 = `(${item.categoryNameJp}-${temp.adaptTypeNameJp})`
        category = item
        adapt = temp
      }
    })
  })
  return {
    name: text ?? '-',
    name2: text2 ?? '-',
    category,
    adapt
  }
}

export default () => {
  // 购物车列表
  const requestNum = ref(0)
  const choiceCartList = ref([])
  const choiceApi = getChoiceCartListApi
  const getPriceAllIncludeApi = calculatePriceAllIncludeApi
  // const choiceApi = (getChoiceCartListApi)
  // const getPriceAllIncludeApi = (calculatePriceAllIncludeApi)
  // 运输方式1:海运 2:空运
  const transportType = ref(2)
  const totalAmount: any = ref({
    totalPriceCNY: 0,
    totalPriceJPY: 0,
    totalQuantity: 0
  })
  // 1直发 0囤货
  const modeValue = ref(1)
  const getChoiceList = async (mode?: number, keepCheck?: boolean) => {
    // 获取类目 获取最小起订量
    if (priceTypeList.value.length === 0) {
      requestNum.value++
      const { data } = await request.settlement.allInclude.categoryAdaptInfo().finally(() => requestNum.value--)
      priceTypeList.value = data ?? []
    }
    modeValue.value = mode ?? modeValue.value
    // 获取choice商品
    requestNum.value++
    const resData = await request.order.cart.listAllInclude({
      orderType: modeValue.value === 1 ? 1 : 2,
      transportType: transportType.value
    }).finally(() => requestNum.value--)
    const l: any = margeListData(resData.data ?? []).map((item: any) => {
      item.cartList?.forEach(async (cartItem: any) => {
        cartItem.check = keepCheck ? !!checkMap.value[cartItem.cartId] : false
        if (item.disabled) {
          cartItem.check = false
        }
        const priceTypeInfo = await getPriceTypeInfo(cartItem.season)
        cartItem.categoryMinQuantity = priceTypeInfo.category?.minQuantity
        cartItem.categoryCode = priceTypeInfo.category?.categoryCode
        cartItem.category = priceTypeInfo.category
        item.categoryNameJp = priceTypeInfo.category?.categoryNameJp
        item.category = priceTypeInfo.category
        item.categoryMinQuantity = priceTypeInfo.category?.minQuantity
      })
      return item
    })
    l.forEach((item: any) => {
      item.allCheck = keepCheck ? item.cartList.every((v: any) => v.check) : false
    })
    choiceCartList.value = l
    console.log(l, 'choiceCartList')

    // calcCheckPrice()
  }
  // 选中商品集合
  const checkMap: any = ref({})
  // 选中分类数量集合
  const checkCategoryNumberMap: any = ref({})
  // 选中spu数量集合
  const checkProductNumberMap: any = ref({})
  watch(
    choiceCartList,
    (newValue) => {
      const map: any = {}
      const numMap: any = {}
      const productNumMap: any = {}
      newValue?.forEach((cartItem: any) => {
        cartItem?.cartList?.forEach((item: any) => {
          if (item.check) {
            map[item.cartId] = { ...item }
            if (!numMap[item.categoryCode]) {
              numMap[item.categoryCode] = 0
            }
            if (numMap[item.categoryCode]) {
              numMap[item.categoryCode] += item.orderQuantity
            } else {
              numMap[item.categoryCode] = item.orderQuantity
            }
            productNumMap[item.productCode] = (productNumMap[item.productCode] ?? 0) + item.orderQuantity
          }
        })
      })
      checkCategoryNumberMap.value = numMap
      checkProductNumberMap.value = productNumMap
      // 判断起订量
      Object.keys(map).forEach((mapItem) => {
        map[mapItem] = {
          ...map[mapItem],
          lackMap: isHaveMinOrderQuantity(map[mapItem])
        }
      })
      checkMap.value = map
    },
    {
      deep: true
    }
  )
  // 监听勾选变化重新计算价格
  watch(
    checkMap,
    (oldValue, newValue) => {
      const diff = diffCheckMap(oldValue, newValue)
      if (diff) {
        // 重新算价
        calcCheckPrice()
      }
    },
    {
      deep: true
    }
  )
  const diffCheckMap = (oldValue: any, newValue: any) => {
    let isDiff = false
    if (Object.keys(oldValue).length !== Object.keys(newValue).length) {
      return true
    }
    console.log('diffCheckMap', newValue)
    Object.keys(oldValue).forEach((item) => {
      // 数量不同
      if (oldValue[item].orderQuantity !== newValue[item].orderQuantity) {
        isDiff = true
      }
      // 附加项不同
      if (oldValue[item].cartAdditionList?.map((v:{additionConfigId:number}) => v.additionConfigId).join(',') !== newValue[item].cartAdditionList?.map((v:{additionConfigId:number}) => v.additionConfigId).join(',')) {
        isDiff = true
      }
    })
    return isDiff
  }
  // 修改运输方式
  const changeTransportType = (type: number) => {
    if (type === transportType.value) return
    transportType.value = type
    calcCheckPrice()
  }
  const isHaveMinOrderQuantity = (item: any) => {
    const obj = {
      lack: false,
      minQuantity: null,
      type: 'category',
      goodsLack: false
    }
    if (modeValue.value === 1) {
      obj.minQuantity = item.categoryMinQuantity
      // 直发只校验类目起订量
      if (checkCategoryNumberMap.value[item.categoryCode] < item.categoryMinQuantity) {
        obj.lack = true
      }
    } else {
      // 先校验商品本身起订量
      if (checkProductNumberMap.value[item.productCode] < item.minOrderQuantity) {
        obj.goodsLack = true
        obj.minQuantity = item.minOrderQuantity
        obj.type = 'goods'
      } else if (checkCategoryNumberMap.value[item.categoryCode] < item.categoryMinQuantity) {
        // 再校验类目起订量
        obj.lack = true
        obj.minQuantity = item.categoryMinQuantity
        obj.type = 'category'
      }
      // // 囤货类目和商品起订量取最大值
      // if (item.categoryMinQuantity > item.minOrderQuantity) {
      //   if (checkCategoryNumberMap.value[item.categoryCode][item.productCode] < item.categoryMinQuantity) {
      //     obj.lack = true
      //     obj.minQuantity = item.categoryMinQuantity
      //   }
      // } else {
      //   if (checkProductNumberMap.value[item.productCode] < item.minOrderQuantity) {
      //     obj.lack = true
      //     obj.minQuantity = item.minOrderQuantity
      //     obj.type = 'goods'
      //   }
      // }
    }
    return obj
  }
  // 校验商品是否满足起订量
  const getCartIdLackStatus = (item: any) => {
    // 是否有其他组合满足起订量需求
    if (checkMap.value[item.cartId]?.lackMap?.lack && !checkMap.value[item.cartId]?.lackMap?.goodsLack) {
      // 如果不满足起订量，则看他有没有别的商品搭配购买，如果有不提示
      const isHaveOtherGoods = Object.values(checkMap.value).length > 1
      if (isHaveOtherGoods) {
        console.log('如果搭配其他商品一起购买', checkProductNumberMap.value[item.productCode], item.minOrderQuantity)
        // 如果搭配其他商品一起购买
        return {
          lack: !Object.values(checkMap.value).some((v:any) => !v?.lackMap?.lack && !v?.lackMap?.goodsLack),
          // 直发取类目起订量 囤货取商品起订量
          minQuantity: item.categoryMinQuantity,
          type: 'category',
          hasOther: true
        }
      }
    }
    return checkMap.value[item.cartId]?.lackMap
  }
  // 勾选商品算价
  const calcCheckPrice = debounce(async () => {
    // // 恢复原价
    await getChoiceList(modeValue.value, true)
    const ids = Object.keys(checkMap.value) ?? []
    if (ids.length === 0) {
      totalAmount.value = {
        totalPriceCNY: 0,
        totalPriceJPY: 0,
        totalQuantity: 0
      }
      return
    }
    requestNum.value++
    const { data } = await getPriceAllIncludeApi({
      cartIdList: ids,
      orderType: modeValue.value === 1 ? 1 : 2,
      transportType: transportType.value
    }).finally(() => requestNum.value--)
    choiceCartList.value.forEach((item: any) => {
      item.cartList.forEach((temp: any) => {
        const productPriceResultItem = data.productResult.productPriceResult.find((v: any) => v.cartId === temp.cartId)
        if (productPriceResultItem) {
          temp.allIncludePriceResult = productPriceResultItem
        }
      })
    })
    totalAmount.value = {
      ...data,
      totalPriceCNY: data.totalAmtCn,
      totalPriceJPY: data.totalAmt,
      totalQuantity: ids.reduce((total: number, v: any) => total + (checkMap.value[v].orderQuantity ?? 0), 0)
    }
    if (data.totalAmt < 150000 && transportType.value === 1) {
      // 如果金额小于15万并且是船运则需要切换空运重新计算价格
      transportType.value = 2
      message.warning(t('已为您自动切换物流，订单低于15万日元，只能选择空运，订单高于15万日元，可选择海运或空运'))
      // await getChoiceList(modeValue.value, true)
      // 重新计算勾选价格
      await calcCheckPrice()
    }
  }, 1000)

  const getChoiceCheckList = () => {
    return Object.keys(checkMap.value).map((v) => checkMap.value[v])
  }
  const margeListData = (cartList: any) => {
    const noPriceType: any = {
      cartList: [],
      disabled: true,
      cartGroupName: t('计价规格缺失商品'),
      noPriceType: true
    }
    const invalidGoods: any = {
      cartList: [],
      disabled: true,
      cartGroupName: t('失效商品'),
      invalidGoods: true
    }
    const normalList: any = []
    cartList.forEach((item: any) => {
      if (item.cartList.filter((v: any) => v.season && ![1, 2, 6, 8, 10].includes(v.productStatus)).length > 0) {
        normalList.push({
          ...item,
          cartList: item.cartList.filter((v: any) => v.season && ![1, 2, 6, 8, 10].includes(v.productStatus))
        })
      }
      item.cartList?.forEach((cartItem:any) => {
        if ([1, 2, 6, 8, 10].includes(cartItem.productStatus) || (cartItem.fixedPriceFlag !== 1 && cartItem.switchAllIncludePriceJp !== 1)) {
          cartItem.check = false
          invalidGoods.cartList.push(cartItem)
          return
        }
        if (!cartItem.season) {
          cartItem.check = false
          noPriceType.cartList.push(cartItem)
        }
      })
    })
    return [
      ...normalList,
      ...(noPriceType.cartList.length > 0 ? [noPriceType] : []),
      ...(invalidGoods.cartList.length > 0 ? [invalidGoods] : [])
    ]
  }
  return {
    requestNum,
    choiceCartList,
    transportType,
    changeTransportType,
    totalAmount,
    checkMap,
    choiceFn: {
      getChoiceList,
      calcCheckPrice,
      getPriceTypeInfo,
      getCartIdLackStatus,
      getChoiceCheckList
    }
  }
}
